import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnChanges {
  @Input() imgUrl: string;
  @Input() isLarge: boolean;
  @Input() isSmall: boolean;
  styleObj: { backgroundImage: string };

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'imgUrl') {
        this.styleObj = {
          backgroundImage: this.imgUrl ? `url('${this.imgUrl}')` : 'url("https://firebasestorage.googleapis.com/v0/b/sleip-app.appspot.com/o/common%2Fimages%2FSleip-256x256.jpg?alt=media&token=76ab8158-54e5-4786-a448-b185fe84ba3e")'
        };
      }
    }
  }

}
